import { useAuthor } from './useAuthor';
import { genUserName } from '@/lib/genUserName';

/** Returns a short display name for a pubkey, using kind-0 metadata when available. */
export function useMentionName(pubkey: string): string {
  const author = useAuthor(pubkey);
  const meta = author.data?.metadata;
  return meta?.name ?? meta?.display_name ?? genUserName(pubkey);
}
